import React                from 'react';
import ReactDOM             from 'react-dom';
import MuiThemeProvider     from '@material-ui/core/styles/MuiThemeProvider';
import { createMuiTheme } from '@material-ui/core/styles';


import { ServiceWorker}     from './services';
import Main                 from './Main'
import { themeConfig }      from './components/ds/theme';
import { ToastProvider }    from './components/ds/Toast';
import 'cropperjs/dist/cropper.css';
import './main.css';
import 'whatwg-fetch';
import Events from 'minivents';

const ROOT_ELEMENT_ID  = 'root';
const RootElement      =  document.getElementById(ROOT_ELEMENT_ID);

const theme = createMuiTheme(themeConfig);



window.events = new Events();


ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <ToastProvider>
      <Main />
    </ToastProvider>
  </MuiThemeProvider>
, RootElement);
ServiceWorker();